import React, {useState} from 'react';
import iconElement from '../assets/images/features/icon-element.svg';
import iconHierarchy from '../assets/images/features/icon-hierarchy.svg';
import iconSchoolBag from '../assets/images/features/icon-school-bag.svg';
import iconRobot from '../assets/images/features/icon-robot.svg';
import iconCam from '../assets/images/features/icon-cam.svg';
import iconFlask from '../assets/images/features/icon-flask.svg';
import CoverImage from "../assets/images/ben-white-PtBu0CmK3jI-unsplash.jpg"
import {ChevronDown, ChevronUp} from "lucide-react";
import {Helmet} from "react-helmet";

function Home() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleIndex = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "How can I get free legal aid?",
            answer: "You can qualify for free legal aid by meeting our eligibility requirements, including income level and type of case."
        },
        {
            question: "What types of cases do you handle?",
            answer: "We specialize in child rights cases, human rights violation cases, family probate and administration, civil cases, and any other cases where injustice or corruption is involved."
        },
        {
            question: "Do I qualify for your services?",
            answer: "If your case aligns with our areas of practice, we’ll be happy to represent you."
        }
    ];
    return (

        <>
           <Helmet>
  <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://www.chicalac.org/#organization",
      "name": "Child Care Legal Aid Clinic (CHICALAC)",
      "url": "https://www.chicalac.org",
      "logo": "https://www.chicalac.org/logo.png",
      "description": "CHICALAC provides free legal aid, consultation, and representation for child rights, family law, and human rights cases in Kenya.",
      "foundingDate": "2010",
      "areaServed": {
        "@type": "Country",
        "name": "Kenya"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "1860 Ronald Ngala Street",
        "addressLocality": "Eldoret",
        "addressRegion": "Uasin Gishu County",
        "postalCode": "30100",
        "addressCountry": "KE"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+254737870943",
        "contactType": "Legal Aid Support"
      },
      "sameAs": [
        "https://web.facebook.com/people/Child-Care-Legal-Aid-Clinic-CHICALAC/100064835043019/"
      ]
    }
    `}
  </script>
</Helmet>
<Helmet>
  <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://www.chicalac.org/#website",
      "url": "https://www.chicalac.org",
      "name": "Child Care Legal Aid Clinic (CHICALAC)",
      "publisher": {
        "@id": "https://www.chicalac.org/#organization"
      }
    }
    `}
  </script>
</Helmet>



            <section className="relative overflow-hidden bg-white">
                <div className="container mx-auto px-2">
                    <div className="flex flex-col lg:flex-row pt-6 lg:pt-20 gap-4">

                        {/* Left Column - Text Content */}
                        <div className="w-full lg:w-1/2 z-10">
                            <h1 className="font-heading text-4xl xs:text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
                                <span>Legal Aid for </span>
                                <span className="font-serif italic">Everyone</span>
                            </h1>

                            <div className="flex mb-8 max-w-md">
                                <div className="mr-4 pt-2">
                                    <svg width="84" height="10" viewBox="0 0 84 10" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1 4.25C0.585786 4.25 0.25 4.58579 0.25 5C0.25 5.41421 0.585786 5.75 1 5.75L1 4.25ZM84 5.00001L76.5 0.669879L76.5 9.33013L84 5.00001ZM1 5.75L77.25 5.75001L77.25 4.25001L1 4.25L1 5.75Z"
                                            fill="#1E254C"
                                        />
                                    </svg>
                                </div>
                                <p className="text-gray-800 md:text-xl font-semibold">
                                    Child Care Legal Aid Clinic provides free legal aid services to underserved
                                    communities since 2010.
                                </p>
                            </div>

                            {/* CTA Button */}
                            <a
                                className="relative group inline-block w-full sm:w-auto py-4 px-6 text-white font-semibold rounded-md bg-orange-900 overflow-hidden"
                                href="/contact"
                            >
                                <div
                                    className="absolute top-0 right-full w-full h-full bg-gray-900 transform group-hover:translate-x-full group-hover:scale-102 transition duration-500"></div>
                                <div className="relative flex items-center justify-center">
                                    <span className="mr-4">Get Legal Help Now</span>
                                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.83 5.29L2.59 1.05C2.49704 0.956274 2.38644 0.881879 2.26458 0.83111C2.14272 0.780342 2.01202 0.754204 1.88 0.754204C1.74799 0.754204 1.61729 0.780342 1.49543 0.83111C1.37357 0.881879 1.26297 0.956274 1.17 1.05C0.983753 1.23736 0.879211 1.49082 0.879211 1.755C0.879211 2.01919 0.983753 2.27264 1.17 2.46L4.71 6L1.17 9.54C0.983753 9.72736 0.879211 9.98082 0.879211 10.245C0.879211 10.5092 0.983753 10.7626 1.17 10.95C1.26344 11.0427 1.37426 11.116 1.4961 11.1658C1.61794 11.2155 1.7484 11.2408 1.88 11.24C2.01161 11.2408 2.14207 11.2155 2.26391 11.1658C2.38575 11.116 2.49656 11.0427 2.59 10.95L6.83 6.71C6.92373 6.61704 6.99813 6.50644 7.04889 6.38458C7.09966 6.26272 7.1258 6.13201 7.1258 6C7.1258 5.86799 7.09966 5.73728 7.04889 5.61543C6.99813 5.49357 6.92373 5.38297 6.83 5.29Z"
                                            fill="#FFF2EE"
                                        />
                                    </svg>
                                </div>
                            </a>

                            {/* Mobile Image shown after button */}
                            <div className="block md:hidden mt-6">
                                <img loading="lazy"
                                    src={CoverImage}
                                    alt="Children together"
                                    className="w-full h-auto rounded-lg"
                                />
                            </div>
                        </div>

                        {/* Right Column - Hero Image on md+ */}
                        <div className="hidden lg:block w-full lg:w-1/2 relative">
                            <img loading="lazy"
                                src={CoverImage}
                                alt="Group of children"
                                className="w-full h-full object-cover rounded-lg"
                            />
                            <div
                                className="absolute bottom-2 right-2 text-[10px] text-gray-400 bg-white/70 px-2 py-1 rounded">
                                Photo by{" "}
                                <a
                                    href="https://unsplash.com/@benwhitephotography"
                                    className="underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Ben White
                                </a>{" "}
                                on{" "}
                                <a
                                    href="https://unsplash.com/photos/a-group-of-young-children-standing-next-to-each-other-PtBu0CmK3jI"
                                    className="underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Unsplash
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Stats Section - pushed BELOW image on lg */}
                    <div className="mt-16 lg:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 z-10 relative">
                        <div className="bg-orange-50 rounded-2xl p-6 flex flex-col items-center text-center">
                            <span className="text-4xl sm:text-5xl font-semibold text-gray-900">500+</span>
                            <span className="text-sm text-gray-600">Cases Handled</span>
                        </div>
                        <div className="bg-orange-50 rounded-2xl p-6 flex flex-col items-center text-center">
                            <span className="text-4xl sm:text-5xl font-semibold text-gray-900">98%</span>
                            <span className="text-sm text-gray-600">Success Rate</span>
                        </div>
                        <div className="bg-orange-50 rounded-2xl p-6 flex flex-col items-center text-center">
                            <span className="text-4xl sm:text-5xl font-semibold text-gray-900">✓</span>
                            <span className="text-sm text-gray-600">Free Legal Services</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-20 overflow-hidden">
                <div className="container px-4 mx-auto">
                    <div className="max-w-3xl mx-auto text-center">
                    <span
                        className="inline-block py-1 px-3 mb-4 text-xs font-semibold text-orange-900 bg-orange-50 rounded-full">OUR SERVICES</span>
                        <h1 className="font-heading text-5xl xs:text-6xl md:text-7xl font-bold text-gray-900 mb-24">
                            <span>Legal aid services for</span>
                            <span className="font-serif italic">everyone</span>
                        </h1>
                    </div>
                    <div className="max-w-7xl mx-auto">
                        <div className="flex flex-wrap -mx-4 items-center">
                            <div className="w-full lg:w-2/5 xl:w-auto px-4 lg:pb-10 mb-16 lg:mb-0">
                                <div className="mx-auto max-w-sm">
                                    <div className="flex items-center pb-12 mb-12 border-b border-gray-100">
                                        <div
                                            className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-blue-100 rounded-full">
                                            <img loading="lazy"  src={iconElement} alt=""/>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold">Child Rights</h3>
                                            <span
                                                className="text-sm text-gray-950">Child defilement, custody, and family matters</span>
                                        </div>
                                    </div>
                                    <div className="flex items-center pb-12 mb-12 border-b border-gray-100">
                                        <div
                                            className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-orange-100 rounded-full">
                                            <img loading="lazy"  src={iconHierarchy} alt=""/>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold">Injustice Cases</h3>
                                            <span
                                                className="text-sm text-gray-950">Professional legal representation</span>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div
                                            className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-gray-300 rounded-full">
                                            <img loading="lazy"  src={iconSchoolBag} alt=""/>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold">Legal Consultation</h3>
                                            <span
                                                className="text-sm text-gray-950">Free initial consultation available</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
<div className="w-full lg:w-1/5 xl:w-auto mx-auto px-4 xl:-mr-10 mb-16 lg:mb-0 relative">
  <img
    loading="lazy"
    className="block h-80 md:h-100 lg:h-auto xl:h-150 mx-auto rounded-lg"
    src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=300&h=600&fit=crop"
    alt="Children at school"
  />
  {/* Attribution only visible on lg+ */}
  <div className="hidden lg:block absolute bottom-2 right-2 text-[10px] text-gray-400 bg-white/70 px-2 py-1 rounded">
    Photo by{" "}
    <a
      href="https://unsplash.com/@tingeyinjurylawfirm?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
      className="underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      Tingey Injury Law Firm
    </a>{" "}
    on{" "}
    <a
      href="https://unsplash.com/photos/gold-angel-figurine-on-white-surface-NcNqTsq-UVY?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
      className="underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      Unsplash
    </a>
  </div>
</div>



                            <div className="w-full lg:w-2/5 xl:w-auto px-4 lg:pb-10">
                                <div className="mx-auto max-w-sm">
                                    <div className="flex items-center pb-12 mb-12 border-b border-gray-100">
                                        <div
                                            className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-red-200 rounded-full">
                                            <img loading="lazy"  src={iconRobot} alt=""/>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold">Human Rights</h3>
                                            <span
                                                className="text-sm text-gray-950">Violation of human rights</span>
                                        </div>
                                    </div>
                                    <div className="flex items-center pb-12 mb-12 border-b border-gray-100">
                                        <div
                                            className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-yellow-200 rounded-full">
                                            <img loading="lazy"  src={iconCam} alt=""/>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold">Family Probate & Administration</h3>
                                            <span
                                                className="text-sm text-gray-950">Inheritance cases</span>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div
                                            className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-green-200 rounded-full">
                                            <img loading="lazy"  src={iconFlask} alt=""/>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-semibold">Injustice & Corruption</h3>
                                            <span
                                                className="text-sm text-gray-950">Injustice legal support available</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-20">
                <div className="container px-4 mx-auto">
                    <div className="max-w-7xl mx-auto">
                        <div className="flex flex-wrap -mx-4 pb-28">
                            {/* Left Column */}
                            <div className="w-full lg:w-1/2 px-4 mb-12 lg:mb-0">
                                <div className="max-w-md mx-auto lg:mx-0">
                                    <h3 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                                        Need legal <span className="font-serif italic">help</span>?
                                    </h3>
                                    <p className="text-gray-500 mb-16">
                                        Get in touch with our legal experts. We're here to help you navigate your legal
                                        challenges.
                                    </p>

                                </div>
                            </div>

                            {/* Right Column (FAQ) */}
                            <div className="w-full lg:w-1/2 px-4">
                                <div className="max-w-md mx-auto lg:mr-0">
                                    <p className="text-2xl font-semibold text-gray-900 mb-8">
                                        Frequently asked questions about our legal services.
                                    </p>
                                    {faqs.map((faq, idx) => (
                                        <div key={idx} className="pb-5 mb-5 border-b border-gray-200">
                                            <button
                                                onClick={() => toggleIndex(idx)}
                                                className="w-full flex items-center justify-between text-left group"
                                            >
                      <span
                          className={`text-lg text-gray-500 group-hover:text-orange-900 ${openIndex === idx ? "text-orange-900" : ""}`}>
                        {faq.question}
                      </span>
                                                <span className="ml-3">
                        {openIndex === idx ? <ChevronUp className="text-orange-600"/> :
                            <ChevronDown className="text-orange-600"/>}
                      </span>
                                            </button>
                                            {openIndex === idx && (
                                                <p className="mt-2 text-sm text-gray-500">{faq.answer}</p>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Footer */}

                    </div>
                </div>
            </section>

        </>
    )
}

export default Home;